module.exports = __webpack_public_path__ + "static/media/7en.89be1c8b.jpg";